export default "__VITE_ASSET__DkudjfYg__"